import { ErrorMessage, Field, Formik, Form } from "formik";
import { AdjuntarProductoDTO, getVoidAdjuntarProductoDTO } from "../../interfaces/ProductosDTOS/AdjuntarProyectoDTO"
import { useNavigate } from 'react-router-dom';
import { Alert, Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select, SelectChangeEvent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import * as Yup from 'yup';
import { TipoProductoDTO } from "../../interfaces/TipoProductoDTO";
import { ProductoColaboradorDTO, setListProductoColaborador } from "../../interfaces/ColaboradorProdcutoDTO";
import { Unidad } from "../../interfaces/Unidad";
import { useEffect, useState } from "react";
import CatalogService, { RolColaboradorProducto } from "../../services/CatalogService";
import { ObjetoLabelFilter } from "../../interfaces/ObjetoLabel";
import {MdAssignmentReturn} from 'react-icons/md';
import { RiSave3Fill } from 'react-icons/ri';
import { FormLabelHandle, FormTypeHandle } from "../../interfaces/ProductoTerminadoDTO";
import { CatagNumberDTO } from "../../interfaces/CatalogoDTO";
import ProyectoService from "../../services/ProyectoService";
import { ProyectoColaboradoreDTO } from "../../interfaces/ProyectoColaboradoreDTO";
import { setProductoTerminado } from "../../interfaces/TblProductoProdTermin";
import ProductoService from "../../services/ProductoService";
import AlertService from "../../services/AlertService";
import { setProductoMotivo } from "../../interfaces/TblDecInvMotivoProdTermin";
import {format, parse} from 'date-fns';

const catalogService = new CatalogService();
const proyectoService = new ProyectoService();
const productoService = new ProductoService();
const alertaService = new AlertService();

const validationSchema = Yup.object().shape({
    idproyecto: Yup.string().test('requiredIfProyecto', 'Se debe seleccionar un proyecto', function(value) {
        const tiene = this.parent.tieneProyecto;
        const idpro = this.parent.idproyecto;
        if (tiene === 'S') {
          return idpro > 0;
        }
        return true;
    }),
});

interface Props{
    productoDTO: AdjuntarProductoDTO,
    tipoProductos: Array<TipoProductoDTO>,
    idinvestigador: number,
    token: any,
    onResponse?: (dataRespuesta: AdjuntarProductoDTO) => void // Función para pasar la respuesta al padre
}

interface codObservacion{
    mensaje: string,
    tipo: number,
}

export default function AdjuntarProyForm(parametro:Props) {
    let history = useNavigate()
    const [unidades,setUnidades] = useState<Array<Unidad>>([])
    const [tipoColaborador,setTipoColaborador] = useState<Array<ObjetoLabelFilter>>([])
    const [listRolColaborador,setListRolColaborador] = useState<Array<ObjetoLabelFilter>>(RolColaboradorProducto)
    const [misProyectos,setMisProyectos] = useState<Array<CatagNumberDTO>>([])
    let [colaboradoresProyecto, setColaboradoresProyecto] = useState<Array<ProyectoColaboradoreDTO>>([])
    
    useEffect(() => {
        fetchData();
    },[parametro.token]);
    //#region Funciones
    const goToNavigation = (site:string) =>{
        history(site)
    }
    const fetchData = async () =>{
        //console.log(parametro.productoDTO.colProducto);
        setTipoColaborador(catalogService.getTipoColaborador)  
        setListRolColaborador(RolColaboradorProducto)
        await catalogService.obtenerGetMisProyectosAprobados(parametro.idinvestigador,parametro.token)
              .then((data) => {
                   //console.log(data);
                   if(data.status.isSuccessfully){
                     setMisProyectos(data.listData);
                   }                  
               })               
              .catch((error) => console.error(error));
        await catalogService.obtenerCatalogoUnidades()
              .then((data) => setUnidades(data.objDatos))
              .catch((error) => console.error(error)) 
    }
    function nombreUnidad(idunidad: number){
        let nunidad = '';
        let u = unidades.find(p => p.idunidad === idunidad)
        if(u !== null){
            nunidad = u?.nombreunidad??'';
        }
        return nunidad;
    }
    function nombreTipoColaborador(tipo: number):string{
        let ntipo = '';
        let c = tipoColaborador.find(p => p.id === tipo)
        if( c !== null){
            ntipo = c?.label??'';
        }
        return ntipo;
    }
    function nombreParticipacion(tipo: number):string{
        let ntipo = '';
        let c = listRolColaborador.find(p => p.id === tipo)
        if( c !== null){
            ntipo = c?.label??'';
        }
        return ntipo;
    }
    function ObservacionColProducto(cedula: string):codObservacion{
        let mensaje = {mensaje: '', tipo: 0}
        if(colaboradoresProyecto.length === 0){
            mensaje.mensaje = 'No hay proyecto para comparar';
            mensaje.tipo = 0;
        }else{
            let colProy = colaboradoresProyecto.find(p => p.cedula === cedula);
            //console.log(colProy);
           if(colProy !== undefined){
             mensaje.mensaje = 'Es colaborador de proyecto';
             mensaje.tipo = 1;
            }else{
             mensaje.mensaje = 'No es colaborador de proyecto';
             mensaje.tipo = 2;
            }
        }
        return mensaje;
    }
    function ListEstadoProyectoHandle(listIndex: Array<CatagNumberDTO>,id:number): string{
        let op = listIndex.find(x => x.codigo === id);
        let str = "";
        if(op != null){
            str = op.infoExtra??"";
        }
        return str;
    }
    function setListColaboradores(idproyecto:number){
        proyectoService.GetColaboradoresProyectoById(idproyecto,parametro.token)
            .then((data) => {
                //console.log(data.listData);
                setColaboradoresProyecto(data.listData);
            })               
            .catch((error) => console.error(error));
    }
    const save = async (values:any) =>{
        // console.log("Post: ",values);
        alertaService.showLoading("Espere...");
        let object = getVoidAdjuntarProductoDTO();
        object.idUsuarioAdjun = parametro.idinvestigador;
        object.producto = setProductoTerminado(parametro.productoDTO.producto);
        object.producto.iddecinvproyecto = values.idproyecto;
        object.producto.fechapublicacion = values.fechapublicacion;
        object.producto.fevento = values.fevento;
        object.producto.fvencimiento = values.fvencimiento;
        object.producto.sjr = parametro.productoDTO.producto.sjr.toString();
        object.motivo = setProductoMotivo(parametro.productoDTO.motivo);
        object.colProducto = setListProductoColaborador(values.colaboradores);
        //console.log(object);
        const resp = await productoService.GuardarAdjuntarProyectoContext(object,parametro.token);
        alertaService.hideLoading();
        //console.log(resp);
        if(resp.status.isSuccessfully) {
            if (parametro.onResponse) {
                    parametro.onResponse(resp.data);
            } else {
                console.error('La función onResponse no está definida.');
            }            
        }else{
                alertaService.alertaAdvertenciaList("Alerta",resp.status.messages);
        }
    } 
    //#endregion
    return(
        <Formik 
        initialValues={{
            tipo: parametro.productoDTO.producto.iddecinvtipoproductoesperado,
            anio: parametro.productoDTO.producto.anio,
            colaboradores: parametro.productoDTO.colProducto as Array<ProductoColaboradorDTO>,
            idproyecto: parametro.productoDTO.producto.iddecinvproyecto,
            fechapublicacion: parametro.productoDTO.producto.fechapublicacion.length > 0 ? format(parse(parametro.productoDTO.producto.fechapublicacion, "dd/MM/yyyy H:mm:ss", new Date(1, 0, 1)), "yyyy-MM-dd") : format(new Date(1, 0, 1),'yyyy-MM-dd'),
            fevento: parametro.productoDTO.producto.fevento.length > 0 ? format(parse(parametro.productoDTO.producto.fevento, "d/M/yyyy H:mm:ss", new Date(1, 0, 1)), "yyyy-MM-dd") : format(new Date(1, 0, 1),'yyyy-MM-dd'),
            fvencimiento: parametro.productoDTO.producto.fvencimiento.length > 0 ? format(parse(parametro.productoDTO.producto.fvencimiento, "d/M/yyyy H:mm:ss", new Date(1, 0, 1)), "yyyy-MM-dd") : format(new Date(1, 0, 1),'yyyy-MM-dd'),
            tieneProyecto : 'S',
            estadoProyecto: parametro.productoDTO.producto.iddecinvproyecto === 0 ? '' : ListEstadoProyectoHandle(misProyectos,parametro.productoDTO.producto.iddecinvproyecto),
            resumen: parametro.productoDTO.producto.resumen,
            objGeneral: parametro.productoDTO.producto.objgeneral
        }}
        validationSchema={validationSchema}
        onSubmit={save}        
        >
            {({setFieldValue,values,errors,touched,handleSubmit,handleChange,handleBlur}) => (
            <Form onSubmit={handleSubmit}>
            <Grid className='siempre' container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                    <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.tipo && touched.tipo)} >
                    <InputLabel htmlFor="select-tipo">Producto</InputLabel>
                    <Select
                        labelId="select-tipo"
                        label='Producto'
                        variant="outlined"                
                        name="tipo"
                        value={values.tipo}
                        disabled
                        onChange={handleChange}
                        onBlur={handleBlur}
                        >
                        {/* Ordenar por nombre */}
                        {parametro.tipoProductos.sort((a, b) => {
                            if (a.nombreProducto < b.nombreProducto) return -1;
                            if (a.nombreProducto > b.nombreProducto) return 1;
                            return 0;
                        }).map((tipoP) => (
                            <MenuItem key={tipoP.idProducto} value={tipoP.idProducto} >
                            {tipoP.nombreProducto}                    
                            </MenuItem>
                        ))}
                    </Select>
                    <ErrorMessage name='tipo' className='errorMessage' component="div"/>
                    </FormControl>
                </Grid>
                {values.tieneProyecto === 'S' &&(             
               <>
               <Grid item xs={12} sm={6} md={6} lg={6}>
               <Field 
                    as={TextField}
                    name="estadoProyecto"
                    label="Estado Proyecto: "
                    variant="outlined" 
                    sx={{ m: 1, width: '100%' }}                
                    type="text"
                    values={values.estadoProyecto}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(errors.estadoProyecto && touched.estadoProyecto)}
                    disabled
                    helperText={
                        <ErrorMessage name='estadoProyecto' className='errorMessage' component="div">
                        {(error) => (
                            <Alert severity="error">
                            {error}
                            </Alert>
                        )}
                        </ErrorMessage>
                    }                
                    />
                </Grid>
               </>
            )}
            {values.tieneProyecto === 'S' &&(              
                <Grid item xs={12} sm={12} md={12} lg={12}>
                   <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.idproyecto && touched.idproyecto)} >                   
                   <InputLabel htmlFor="select-idproyecto">Proyecto:</InputLabel>
                   <Select
                    labelId="select-idproyecto"
                    name="idproyecto"
                    label='Proyecto:'
                    variant="outlined"                
                    value={values.idproyecto}
                    onChange={async (e: SelectChangeEvent<number>) => {
                        const selectedValue = e.target.value as number;
                        // Llama a tu función externa para obtener datos de la API
                          try {
                              const apiData = await setListColaboradores(selectedValue);  
                              const estado = ListEstadoProyectoHandle(misProyectos,selectedValue);
                              setFieldValue('estadoProyecto', estado)           
                              handleChange(e);
                          } catch (error) {
                              // Maneja el error aquí si es necesario
                          }
                      }}
                    onBlur={handleBlur}  
                    >
                    <MenuItem key={0} value={0}>
                            {'SIN SELECCIONAR'}
                    </MenuItem>
                    {misProyectos.length > 0 ? (
                        misProyectos.map((tipoP) => (
                            <MenuItem key={tipoP.codigo} value={tipoP.codigo}>
                            {tipoP.descripcion}
                            </MenuItem>
                        ))
                        ) 
                    : (
                     <MenuItem value={''}>No hay proyectos disponibles</MenuItem>
                      )}
                </Select>
                   <ErrorMessage name='idproyecto' className='errorMessage' component="div"/>
                </FormControl>
               </Grid>
            )} 
                <Grid item xs={12} sm={6} md={3} lg={3}>
                    <Field 
                        as={TextField}
                        name="anio"
                        label={FormLabelHandle(values.tipo,'anio')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%'}}                
                        type="text"
                        disabled
                        maxLength={3000}
                        values={values.anio}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.anio && touched.anio)}
                        helperText={<ErrorMessage name='anio' />}                
                    />
                </Grid>
                {values.resumen.length > 0 && (
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Field 
                        as={TextField}
                        name="resumen"
                        label={FormLabelHandle(values.tipo,'resumen')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%'}}                
                        type="text"
                        multiline
                        disabled
                        maxLength={3000}
                        rows={5}
                        values={values.resumen}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.resumen && touched.resumen)}
                        helperText={<ErrorMessage name='resumen' />}                
                    />
                </Grid>)}
                {FormTypeHandle(values.tipo,'objGeneral') && (
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Field 
                        as={TextField}
                        name='objGeneral'
                        label={FormLabelHandle(values.tipo,'objGeneral')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%'}}                
                        type="text"
                        multiline
                        disabled
                        maxLength={3000}
                        rows={5}
                        values={values.objGeneral}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.objGeneral && touched.objGeneral)}
                        helperText={<ErrorMessage name='objGeneral' />}                
                    />
                </Grid>)}
                <Grid item xs={12} sm={12} md={12} lg={12} >
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Cedula</TableCell>
                            <TableCell>Apellidos y Nombres</TableCell>
                            <TableCell>Institucion</TableCell>
                            <TableCell>Rol</TableCell>
                            <TableCell>Observacion</TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {parametro.productoDTO.colProducto.map((row,index) => (
                            <TableRow key={row.iddecinvproyectocolaboradores}>
                            <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                            <TableCell component="th" scope="row">
                                {row.cedula}
                            </TableCell>
                            <TableCell>
                                {row.nombre}
                            </TableCell>
                            <TableCell>
                                {row.tipocolaborador === 1 ? nombreUnidad(row.idunidad) : row.institucion}
                            </TableCell>
                            <TableCell>
                                {nombreParticipacion(row.tipoparticipacion)}
                            </TableCell>
                            <TableCell>
                                {ObservacionColProducto(row.cedula).mensaje}
                            </TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={3}>
                        <Button 
                        color="error"
                        variant="contained"      
                        onClick={() => goToNavigation('/Producto/MisProductos')}                               
                        endIcon={<MdAssignmentReturn />} >
                        Regresar
                        </Button>
                   </Grid>
                   <Grid item xs={12} sm={6} md={3} lg={3}>
                   </Grid>                
                   <Grid item xs={12} sm={6} md={3} lg={3}>
                   </Grid> 
                   <Grid item xs={12} sm={6} md={3} lg={3}>
                    <Button 
                        type='submit'
                        variant="contained"                                   
                        endIcon={<RiSave3Fill />} >
                        Guardar
                    </Button>
                </Grid>  
            </Grid>
            </Form>
            )}
        </Formik>
    )
}